let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4A1Hr")).then(() => parcelRequire('dh4Bf'));